import { render, staticRenderFns } from "./LawCounterPartySubTypeList.vue?vue&type=template&id=190ab768&"
import script from "./LawCounterPartySubTypeList.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartySubTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartySubTypeList.vue?vue&type=style&index=0&id=190ab768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports